<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2018 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2018</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">27 26 25 24 23 22 21 20 19 18    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-53412-1 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-53409-1 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-53426-8 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226534268.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226534268.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cip">Names: Löwy, Ilana, 1948– author.</p>
<p class="cip">Title: Tangled diagnoses: prenatal testing, women, and risk / Ilana Lowy.</p>
<p class="cip">Description: Chicago: The University of Chicago Press, 2018. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2017044387 | ISBN 9780226534121 (cloth: alk. paper) | ISBN 9780226534091 (pbk: alk. paper) | ISBN 9780226534268 (e-book)</p>
<p class="cip">Subjects: LCSH: Prenatal diagnosis. | Fetus—Diseases—Diagnosis.</p>
<p class="cip">Classification: LCC RG628 .L68 2018 | DDC 618.3/2075—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2017044387" target="_blank">https://lccn.loc.gov/2017044387</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lowy-0004.vue?5500cfee